import { render, staticRenderFns } from "./CustomAttributesManagementPortal.vue?vue&type=template&id=68fd42b3"
import script from "./CustomAttributesManagementPortal.vue?vue&type=script&lang=ts"
export * from "./CustomAttributesManagementPortal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports